/**
 * Constants for Bulk Upload CSV parsing and validation.
 */

/**
 * Main CSV column headers — matches the user-provided upload format.
 */
export const CSV_HEADERS = {
    NODE_ID: "nodeId",
    CYCLE: "cycle",
    BIN_TYPE: "binType",
    EXCLUDED_AISLES: "excluded_aisles",
    EXCLUDED_BINS: "excluded_bins",
    EXCLUDED_CLUSTERS: "excluded_clusters",
    INCLUDED_SORT_ZONES: "included_sort_zones",
    INCLUDED_AISLES: "included_aisles",
    INCLUDED_COLUMNS: "included_columns",
    BALANCING_SORT_ZONES: "balancing_sort_zones",
    OPTIMISE_CLUSTER_USAGE: "optimise_cluster_usage",
    FILL_ALGORITHM: "fillPathAlgorithm",
    PICK_ALGORITHM: "pickPathAlgorithm",
    FILL_AISLE_ORDER_TYPE: "fill_aisle_order_type",
    FILL_AISLE_CUSTOM_SEQUENCE: "fill_aisle_custom_sequence",
    FILL_AISLE_CLUSTER_SEQUENCE: "fill_aisle_cluster_sequence",
    FILL_CLUSTER_ORDER_TYPE: "fill_cluster_order_type",
    FILL_CLUSTER_CUSTOM_SEQUENCE: "fill_cluster_custom_sequence",
    FILL_CLUSTER_SEQUENCE: "fill_cluster_sequence",
    FILL_ADTA_PRIORITIZATION_ORDER: "fill_adta_prioritization_order",
    FILL_DEPRIORITIZED_TIERS: "fill_deprioritized_tiers",
    FILL_DEPRIORITIZED_TIERS_ADTA: "fill_deprioritized_tiers_adta",
    FILL_FINGER_ORDER: "fill_finger_order",
    FILL_SORT_LOCATION_ORDER: "fill_sort_location_order",
    FILL_SPLIT_PERCENTAGE: "fill_split_percentage",
    FILL_STARTING_AISLE: "fill_starting_aisle",
    PICK_AISLE_ORDER_TYPE: "pick_aisle_order_type",
    PICK_AISLE_CUSTOM_SEQUENCE: "pick_aisle_custom_sequence",
    PICK_AISLE_CLUSTER_SEQUENCE: "pick_aisle_cluster_sequence",
    PICK_CLUSTER_ORDER_TYPE: "pick_cluster_order_type",
    PICK_CLUSTER_CUSTOM_SEQUENCE: "pick_cluster_custom_sequence",
    PICK_CLUSTER_SEQUENCE: "pick_cluster_sequence",
    PICK_COLUMN_LENGTH_ZEBRA: "pick_column_length_zebra_path",
    PICK_COLUMN_SPLIT_RATIO: "pick_column_split_ratio",
    PICK_SORT_LOCATION_ORDER: "pick_sort_location_order",
    PICK_STARTING_AISLE: "pick_starting_aisle",
};

/**
 * Cluster params CSV column headers.
 */
export const CLUSTER_PARAMS_HEADERS = {
    NODE_ID: "nodeId",
    CYCLE: "cycle",
    CLUSTER_NAME: "cluster_name",
    ADTA_ENABLED: "adta_enabled",
    BLOCK_LENGTH: "block_length",
    MAX_CAPACITY: "max_capacity",
};

/**
 * Valid split percentages for COMBINATRIX algorithm.
 */
export const VALID_SPLIT_PERCENTAGES = ["0", "0.35", "0.6", "0.75", "1"];

/**
 * Valid column lengths for PARTIAL_COLUMN_ZEBRA_PATTERN.
 */
export const VALID_COLUMN_LENGTHS = ["3", "4", "5"];

/**
 * Valid ADTA prioritization orders.
 */
export const VALID_ADTA_ORDERS = ["TOP_PRIORITY", "LOW_PRIORITY", "BOTTOM_PRIORITY"];

/**
 * Max allowed length for sort path setting name.
 */
export const MAX_NAME_LENGTH = 20;

/**
 * Max allowed included sort zones for SIDELINE.
 */
export const MAX_SIDELINE_SORT_ZONES = 4;
